export default __webpack_public_path__ + "static/media/arrows.abd7bb26.svg";